import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { ContentHead } from '../../lib/components';
import { ContentBox } from '../../lib/components/compound/pages/contentBox';
import { CardApprovalTable } from '../../lib/components/tables/pxtraCardApproval/approvals';
import { CardOnboardingNotice } from '../../lib/components/compound/pxtraCardOnboarding';

export const CardApprovals = observer(() => {
  const { t } = useTranslation();

  return (
    <ContentBox
      headComponent={
        <ContentHead
          headline={t('pxtraCard:approvals')}
          subtitle={t('pxtraCard:approvalsSubtitle')}
          showActions={false}
        />
      }
    >
      <CardOnboardingNotice />
      <CardApprovalTable />
    </ContentBox>
  );
});
